<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.scheduleId ? (isEdit ? '编辑定时任务' : '查看定时任务') : '新增定时任务'"
    v-bind="$attrs" v-on="$listeners">
    <div class="edit-box flex-c-e" v-show="baseForm.scheduleId">
      <el-button v-if="mixinHasPermi(['monitor:schedule:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child" v-closeSelect>
      <el-form class="clearfix" ref="scheduleFormRef" :model="dialogForm" :rules="rules"
        :disabled="!!(!isEdit && baseForm.scheduleId)" label-width="128px">
        <el-form-item class="half" label="任务名称" prop="scheduleName">
          <el-input v-model.trim="dialogForm.scheduleName" clearable placeholder="请输入任务名称" />
        </el-form-item>
        <el-form-item class="half" label="任务执行标识" prop="taskName">
          <el-select-dict dictType="SCHEDULE_TASK" v-model.trim="dialogForm.taskName" clearable
            placeholder="请选择任务执行标识" />
        </el-form-item>
        <el-form-item class="half" label="cron执行表达式" prop="cron">
          <el-input v-model="dialogForm.cron" placeholder="请输入cron执行表达式">
            <template slot="append">
              <el-button type="primary" @click="handleShowCron">
                生成表达式
                <i class="el-icon-time el-icon--right"></i>
              </el-button>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item class="all" label="备注" prop="remark">
          <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
            placeholder="请输入备注" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.scheduleId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.scheduleId || isEdit">确 定</el-button>
      </template>
    </div>

    <crontab title="Cron表达式生成器" :modal="false" :visible.sync="openCron" width="888px" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" @close="openCron = false" @fill="crontabFill"
      :expression="expression"></crontab>

  </el-dialog>
</template>
<script>
import { scheduleApi } from "@/api"
import checkCron from "@/utils/check-cron"

import Crontab from "@/components/crontab"

export default {
  components: { Crontab },
  name: "ScheduleDialog",
  props: {
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    // 数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    /** 检查用户名是否已存在 */
    const checkScheduleName = (rule, value, callback) => {
      const rex = /[A-Za-z_]+$/
      if (!rex.test(value)) {
        callback("任务名称只能为英文字母或下划线组成！")
        return
      }
      scheduleApi
        .judgeExist({ scheduleName: value, scheduleId: this.baseForm.scheduleId })
        .then((data) => {
          if (data.validateResult) {
            callback()
          } else {
            callback(data.msg)
          }
        })
    }
    const checkScheduleCron = (rule, value, callback) => {
      if (!checkCron(value)) {
        callback("请输入正确的cron执行表达式")
        return
      }
      callback()
    }
    return {
      openCron: false,
      expression: "* * * * * ?",
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        scheduleName: [
          {
            required: true,
            message: "请输入任务名称",
            trigger: ["blur", "change"]
          },
          { validator: checkScheduleName, trigger: "blur" }
        ],
        taskName: [
          {
            required: true,
            message: "请输入任务执行标识",
            trigger: ["blur", "change"]
          }
        ],
        cron: [
          {
            required: true,
            message: "请输入cron执行表达式",
            trigger: ["blur"]
          },
          { validator: checkScheduleCron, trigger: "blur" }
        ]
      }
    }
  },
  watch: {
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /** 确定后回传值 */
    crontabFill(value) {
      this.openCron = false
      this.dialogForm.cron = value
      this.$nextTick(() => {
        this.$refs.scheduleFormRef.validateField("cron")
      })
    },
    /** cron表达式按钮操作 */
    handleShowCron() {
      this.expression = this.dialogForm.cron
      this.openCron = true
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
    },
    // 重置表单
    resetForm() {
      this.isEdit = false
      this.expression = "* * * * * ?"
      this.$nextTick(() => {
        this.$refs.scheduleFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["scheduleFormRef"].validate((valid) => {
        if (valid) {
          //更新
          if (this.dialogForm.scheduleId) {
            scheduleApi.updateSchedule(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑定时任务成功")
              this.$emit("close")
              this.$emit("successs")
            })
          } else {
            //新增
            scheduleApi.addSchedule(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增定时任务成功")
              this.$emit("close")
              this.$emit("successs")
            })
          }
        }
      })
    }
  }
}
</script>
